import React, { useEffect, useState } from "react";
import Tabs, { TabBtnList, TabPane } from "../../components/common/Tabs";
import DynamicContent from "../../components/common/DynamicContent";
import { useMasterValues } from "../../components/common/MasterData";
import { isArray } from "validate.js";
import axios from "axios";

const tbs = ["Sales Accept Lead Report", "Live Location"];

const SalesLeadReport = () => {
  const [fetching, data] = useMasterValues();
  const isLoaded = isArray(data.project) && data.project.length > 0;

  const [leadData, setLeadData] = useState([]);
  const [projects, setProjects] = useState([]);
  const [allSources, setAllSources] = useState([]);
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [allPrimarySources, setAllPrimarySources] = useState([]);

  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [filteredPrimarySources, setFilteredPrimarySources] = useState([]);

  const [sms, setSms] = useState([
    { 'id': 26, 'name': 'Sabarinathan' },
    { 'id': 27, 'name': 'Dhanasekar' },
    { 'id': 28, 'name': 'Raja' },
    { 'id': 29, 'name': 'Sivachandraan' },
    { 'id': 30, 'name': 'Aravindh' },
    { 'id': 98, 'name': 'Mohan' },
    { 'id': 32, 'name': 'Arun' },
    { 'id': 38, 'name': 'Sivakumar' },
    { 'id': 39, 'name': 'Varun' },
    { 'id': 40, 'name': 'Venkatesh' },
    { 'id': 37, 'name': 'Sidharth' },
    { 'id': 31, 'name': 'Alex pandiyan' },
    // { 'id': 76, 'name': "General Enquiry" }
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [activeFilters, setActiveFilters] = useState({});

  const [filters, setFilters] = useState({
    name: "",
    number: "",
    email: "",
    source: "",
    campaign: "",
    primary_source: "",
    project: "",
    fromDate: "",
    toDate: "",
  });

  // ---------- 1. Fetch ALL dropdowns once ----------
  const fetchDropdowns = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}leads/sales_lead_report/`, {
        params: { fetch_type: "dropdowns" },
      });
      setAllSources(res.data.sources || []);
      setAllCampaigns(res.data.campaigns || []);
      setAllPrimarySources(res.data.primary_sources || []);
      setProjects(res.data.projects || []);
    } catch (err) {
      console.error("Failed to load dropdowns", err);
    }
  };

  // ---------- 2. Filter campaigns & primary sources client-side ----------
  useEffect(() => {
    if (!filters.source) {
      setFilteredCampaigns([]);
      setFilteredPrimarySources([]);
      return;
    }
    const sourceId = allSources.find(s => s.title === filters.source)?.id;
    const camps = allCampaigns.filter(c => c.source_id === sourceId);
    setFilteredCampaigns(camps);
    setFilteredPrimarySources([]);
  }, [filters.source, allSources, allCampaigns]);

  useEffect(() => {
    if (!filters.campaign) {
      setFilteredPrimarySources([]);
      return;
    }
    const campaignId = filteredCampaigns.find(c => c.title === filters.campaign)?.id;
    const primaries = allPrimarySources.filter(p => p.campaign_id === campaignId);
    setFilteredPrimarySources(primaries);
  }, [filters.campaign, filteredCampaigns, allPrimarySources]);

  // ---------- 3. Fetch main data ----------
  const fetchData = async (page = 1, params = activeFilters) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}leads/sales_lead_report/`, {
        params: { page, ...params },
      });
      setLeadData(res.data.results || []);
      setTotalPages(res.data.total_pages || 1);
      setProjects(res.data.projects || []);
    } catch (err) {
      console.error("Error fetching leads", err);
    }
  };

  useEffect(() => {
    fetchDropdowns();
  }, []);

  useEffect(() => {
    fetchData(currentPage, activeFilters);
  }, [currentPage]);

  // ---------- Handle input change ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const buildFilterParams = () => ({
    name: filters.name || "",
    number: filters.number || "",
    email: filters.email || "",
    source: filters.source || "",
    campaign: filters.campaign || "",
    primary_source: filters.primary_source || "",
    project: filters.project || "",
    from_date: filters.fromDate || "",
    to_date: filters.toDate || "",
    salesManager: filters.salesManager || "",
  });

  const handleSearch = () => {
    const params = buildFilterParams();
    setActiveFilters(params);
    setCurrentPage(1);
    fetchData(1, params);
  };

  const handleDownload = () => {
    if (!leadData || leadData.length === 0) {
      alert("No data available to download.");
      return;
    }

    const headers = [
      "Sales Manager",
      "Date",
      "Accept Lead",
      "Project",
      "Login Time",
      "Logout Time",
      "Lead No",
      "Customer Name",
      "Number",
      "Email",
      "Source",
      "Campaign",
      "Primary Source",
      "Status",
      "Location",
      "HO Remarks",
      "Login IP"
    ];

    const rows = leadData.map(lead => {
      const locationUrl = lead.latitude && lead.longitude
        ? `=HYPERLINK("https://www.google.com/maps?q=${lead.latitude},${lead.longitude}","View Location")`
        : "-";

      const project = (lead.lead_no === null && lead.head_office_remarks !== "-" && !lead.project_title)
        ? "Head Office"
        : (lead.lead_no !== null && lead.head_office_remarks === "-")
          ? "Customer Visit"
          : lead.project_title || "-";

      // FIXED: Use record_type instead of login_status
      const acceptLead = lead.record_type === 'LOGIN' ? "ON"
        : lead.record_type === 'LOGOUT' ? "OFF"
          : "-";

      return [
        `${lead.sales_manager_first_name || ""} ${lead.sales_manager_last_name || ""}`,
        formatDate(lead.login_time || lead.logout_time),
        acceptLead,
        project,
        formatDateTime(lead.login_time),
        formatDateTime(lead.logout_time),
        lead.lead_no || "-",
        lead.name || "-",
        `${lead.number || "-"} / ${lead.secondary_number || "-"}`,
        `${lead.email || "-"} / ${lead.secondary_email || "-"}`,
        lead.source || "-",
        lead.campaign || "-",
        lead.primary_source || "-",
        lead.status || "-",
        locationUrl,
        lead.head_office_remarks || "-",
        lead.login_ip || "-"
      ];
    });

    const csvContent = [
      headers.join(","),
      ...rows.map(row =>
        row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "sales-lead-report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleViewLiveLocation = async (id, name) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}leads/get-live-location/`, {
        params: { userId: id },
      });

      const { latitude, longitude } = res.data;

      if (latitude && longitude) {
        const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(mapsUrl, "_blank");
      } else {
        alert(`No live location found for ${name}`);
      }
    } catch (error) {
      console.error("Error fetching live location:", error);
      alert(`Error fetching live location for ${name}`);
    }
  };

  const handlePrevPage = () => currentPage > 1 && setCurrentPage(p => p - 1);
  const handleNextPage = () => currentPage < totalPages && setCurrentPage(p => p + 1);

  const formatDateTime = (dt) => {
    if (!dt) return "-";
    return new Date(dt).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
  };

  const formatDate = (dt) => {
    if (!dt) return "-";
    return new Date(dt).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };

  return (
    <div>
      <Tabs qName="sub_tab" tabs={tbs}>
        <div className="d-flex justify-content-center mt-2">
          <TabBtnList />
        </div>
        <TabPane tabId={tbs[0]}>
          <DynamicContent fetching={fetching} isLoaded={isLoaded}>
            {isLoaded && (
              <div className="p-3">

                <div className="row g-2 mb-3">

                  <div className="col-md-3 mt-3">
                    <select
                      name="salesManager"
                      value={filters.salesManager}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Sales Manager</option>
                      {sms.map((sm) => (
                        <option key={sm.id} value={sm.id}>
                          {sm.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3 mt-3">
                    <select
                      name="project"
                      value={filters.project}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Project</option>
                      {projects.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3 mt-3">
                    <input
                      type="date"
                      name="fromDate"
                      value={filters.fromDate}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="From Date"
                    />
                  </div>

                  <div className="col-md-3 mt-3">
                    <input
                      type="date"
                      name="toDate"
                      value={filters.toDate}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="To Date"
                    />
                  </div>

                  <div className="col-md-2 mt-3">
                    <button className="btn btn-primary w-100" onClick={handleSearch}>
                      Search
                    </button>
                  </div>

                  <div className="col-md-2 mt-3">
                    <button className="btn btn-primary w-100" onClick={handleDownload}>
                      Download
                    </button>
                  </div>
                </div>

                {/* ==== TABLE ==== */}
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Sales Manager</th><th>Date</th><th>Accept Lead</th><th>Project</th><th>Login Time</th><th>Logout Time</th>
                        <th>Lead No</th> <th>Customer Name</th><th>Number</th><th>Email</th>
                        <th>Source</th><th>Campaign</th><th>Primary Source</th><th>Status</th>
                        <th>Location</th><th>Remarks</th><th>Login IP</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leadData.length > 0 ? leadData.map((lead, i) => (
                        <tr key={i}>
                          <td>{lead.sales_manager_first_name} {lead.sales_manager_last_name}</td>
                          <td>{formatDate(lead.login_time || lead.logout_time)}</td>
                          {/* FIXED: Use record_type */}
                          <td>
                            {lead.record_type === 'LOGIN' ? 'ON' :
                              lead.record_type === 'LOGOUT' ? 'OFF' :
                                '-'}
                          </td>
                          <td>
                            {
                              lead?.project_title
                                ? lead.project_title
                                : lead?.lead_no
                                  ? "Customer Visit"
                                  : "Head Office"}
                          </td>
                          <td>{lead.login_time ? formatDateTime(lead.login_time) : "-"}</td>
                          <td>{lead.logout_time ? formatDateTime(lead.logout_time) : "-"}</td>
                          <td>{lead.lead_no || "-"}</td>
                          <td>{lead.name || "-"}</td>
                          <td>{lead.number || "-"} / {lead.secondary_number || "-"}</td>
                          <td>{lead.email || "-"} / {lead.secondary_email || "-"}</td>
                          <td>{lead.source || "-"}</td>
                          <td>{lead.campaign || "-"}</td>
                          <td>{lead.primary_source || "-"}</td>
                          <td>{lead.status || "-"}</td>
                          <td>
                            {lead.latitude && lead.longitude ? (
                              <a href={`https://www.google.com/maps?q=${lead.latitude},${lead.longitude}`}
                                target="_blank" rel="noopener noreferrer">View Location</a>
                            ) : "-"}
                          </td>
                          <td>{lead.head_office_remarks || "-"}</td>
                          <td>{lead.login_ip || "-"}</td>
                        </tr>
                      )) : (
                        <tr><td colSpan="16" className="text-center">No data available</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* ==== PAGINATION ==== */}
                <div className="d-flex justify-content-between mt-3">
                  <button className="btn btn-secondary" onClick={handlePrevPage}
                    disabled={currentPage <= 1}>Previous</button>
                  <span>Page {currentPage} of {totalPages}</span>
                  <button className="btn btn-secondary" onClick={handleNextPage}
                    disabled={currentPage >= totalPages}>Next</button>
                </div>

              </div>
            )}
          </DynamicContent>
        </TabPane>

        <TabPane tabId={tbs[1]}>
          <div className="p-3">
            <h4 className="mb-3 text-center">Live Location of Sales Managers</h4>

            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Sales Manager Name</th>
                    <th style={{ width: "20%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sms.length > 0 ? (
                    sms.map((manager) => (
                      <tr key={manager.id}>
                        <td>{manager.name}</td>
                        <td>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => handleViewLiveLocation(manager.id, manager.name)}
                          >
                            View Live Location
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No sales managers found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </TabPane>

      </Tabs>
    </div>
  );
};

export default SalesLeadReport;